import { createTheme as r } from "./ghl-ui.es855.js";
import e from "./ghl-ui.es1157.js";
import m from "./ghl-ui.es903.js";
import n from "./ghl-ui.es1029.js";
const i = (t) => {
  const {
    textColorDisabled: o
  } = t;
  return {
    iconColorDisabled: o
  };
}, u = r({
  name: "InputNumber",
  common: e,
  peers: {
    Button: m,
    Input: n
  },
  self: i
}), b = u;
export {
  b as default
};
